module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('Catalog_List_Latest', {

		configure: function () {
			this.moreEventsAvailable = true;
			this.masonryApplied = false;
			this.searchKeyword = false;

			this.eventsAliases = {
				1: 'liveshow',
				2: 'post',
				3: 'message',
				4: 'trip',
				5: 'custom',
				6: 'photoset',
				7: 'video',
				8: 'join'
			}

			this.contentTypes = [1, 2, 6, 7];

			this.registerOptions('', {
				widgets: {
					eventsFilter: {
						widget: 'Widget',
						autoRender: true,
						container: '.models-filter',
						template: 'catalog_filter_latest',
						widgets: {
							search: {
								widget: 'Autocomplete2'
							}
						},

						handleDom: {
							selectChange: {
								target: 'select',
								event: 'change',
								callback: '@parent:_handleSelectChange'
							},
							clearSearch: {
								target: '.icon.clear',
								event: 'click',
								callback: '@parent:_clearSearch'
							}
						},

						handleWom: {
							searchFormSubmit: {
								widget: '#search',
								event: 'search_form_submit',
								callback: '@parent:_searchByName'
							}
						},

						'hooks.onAddedToDom': fox.bind(function () {
							var gender = fox.Navigator.get('gender');
							var name = fox.Navigator.get('name');

							if (gender) {
								this.updateFilterOnLoad('gender', this.genders[gender], true);
								//this.updateGenderSelect(this.genders[gender]);
							}
							if (name) {
								this.updateFilterOnLoad('name', name);
								this.setFilterParams('name', name);
								this.loadEvents();
							}
						}, this)
					}
				}
				
			});

			this.callParent('configure', arguments);
		},

		_handleSelectChange: function (el, skipEvent) {
			var opt = el.options[el.selectedIndex];
			var parent = el.parentNode;
			$('.txt', parent).text(opt.innerHTML);

			if (el.name == 'gender') {
				$('.icon.begin', parent).html('<i class="' + $(opt).attr('data-icon') + '"></i>');
			}

			if (skipEvent === true) {
				return;
			};

			this.dispatchEvent('select_changed', {name: el.name, value: opt.value})
		},

		_clearSearch: function () {
			this.masonryApplied = false;
			this.searchKeyword = false;
			
			this.setFilterParams('name', false);
			this.loadEvents();
		},

		updateFilterOnLoad: function (alias, value, skipEvent) {
			switch (alias) {
				case 'name':
					this.updateNameInput(value);
				break;

				case 'gender':
					this.updateGenderSelect(value, skipEvent)
				break;
			}
		},

		updateGenderSelect: function (value, skipEvent) {
			var el = this.wom1('#eventsFilter').dom1('[name="gender"]');

			if (!el) {
				return;
			}
			
			$(el).find('option').each(function (i, opt) {
				opt.selected = false;

				if (opt.value == value) {
					opt.selected = true;
				};
			});

			this._handleSelectChange(el, skipEvent);

		},

		updateNameInput: function (value) {
			this.rwom1('#eventsFilter #search').fillInput(window.decodeURI(value));
		},

		prepareResponse: function (response, alias) {
			var collection = response.collection;

			fox.each(collection, function (data) {
				data.eventAlias = this.eventsAliases[data.type];

				if (data.type == 1 || data.type == 7) {
					data.useSlideShow = true;
				}

				if (data.type == 1 && data._typedParams.status == 0 && new Date(data.startDate) < new Date()) {
					data.liveshowSkiped = true
					//data._typedParams.status = 1
				}

				if (fox.inArray(this.contentTypes, data.type) && data.title) {
					data.link = [data.link, fox.utils.toNavigatorAlias(data.title)].join('/');
				}
			}, this);

			//console.log(response)
			this.wom1('#' + alias)._apiResponse = response.dataLayer || response;
		},

		_searchByName: function (obj, w, e) {
			var value = w.getSearchString();
			console.log('_searchByName', value);

			this.searchKeyword = value;

			if (!fox.trim(value).length) {
				this._clearSearch();

				return;
			};

			this.searchByName(value);

			return false;
		},

		_clearSearch: function () {
			this.masonryApplied = false;
			this.searchKeyword = false;
			
			this.setFilterParams('name', false);
			this.loadEvents();
		},

		searchByName: function (str) {
			this.masonryApplied = false;
			this.searchKeyword = str;

			this.setFilterParams('name', str)

			this.loadEvents();
		},

	}, 'Catalog_List');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/catalog/catalog3x/list/latest.js
// module id = 120
// module chunks = 0